import { useRouter } from "next/router";
import Link from "next/link";
import { useEffect, useState } from "react";



const HrNav = ({ isMobile = false }) => {
  const [mounted, setMounted] = useState(false);
  const [showMembersDropdown, setShowMembersDropdown] = useState(false);
  const router = useRouter();

  const isActive = (href) => router.pathname === href;

  useEffect(() => {
    setMounted(true);
  }, []);

  const handleMembersClick = (e) => {
    if (isMobile) {
      e.preventDefault();
      setShowMembersDropdown(!showMembersDropdown);
    }
  };

  if (!mounted) return null;

  return (
    <nav className="mainmenu-nav">
      <ul className="mainmenu">
        {/* 🏠 Home */}
        <li>
          <Link href="/home" className={isActive("/home") ? "active" : ""}>
            🏠 Home
          </Link>
        </li>

        {/* 📢 Announcements */}
        <li>
          <Link
            href="/announcements"
            className={isActive("/announcements") ? "active" : ""}
          >
            📢 Events
          </Link>
        </li>

        {/* 💼 Jobs */}
        <li>
          <Link
            href="/hr-admin/hr-jobs"
            className={isActive("/hr-admin/hr-jobs") ? "active" : ""}
          >
            💼 Jobs
          </Link>
        </li>



        {/* 🔍 Members Dropdown */}
        <li className={`has-dropdown ${isMobile && showMembersDropdown ? 'open' : ''}`}>
          <Link
            href="#"
            onClick={handleMembersClick}
            className={`d-flex align-items-center justify-content-between ${isActive("/list-instructor") || isActive("/hr-admin")
              ? "active"
              : ""
              }`}
            style={{ gap: "6px" }}
          >
            <span>👥 Members</span>
            <i
              className={`fas fa-chevron-${isMobile && showMembersDropdown ? 'up' : 'down'}`}
              style={{ fontSize: "0.8rem" }}
            ></i>
          </Link>

          <ul
            className="submenu"
            style={{
              marginTop: isMobile ? "0" : "-20%",
              display: isMobile ? (showMembersDropdown ? 'block' : 'none') : undefined
            }}
          >
            <li>
              <Link
                href="/list-instructor"
                className={isActive("/list-instructor") ? "active" : ""}
              >
                🧑‍🏫 Instructors
              </Link>
            </li>
            <li>
              <Link
                href="/candidates"
                className={isActive("/candidates") ? "active" : ""}
              >
                🙋‍♂️ Candidates
              </Link>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  );
};

export default HrNav;